import React from 'react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from '../../I18n/components/users';

const DeleteUserModal = props => {
	return (
		<Modal className="del-modal" isOpen={props.isOkModal} toggle={props.toggle}>
			<ModalHeader>{I18n[props.lang].modal.sure}</ModalHeader>
			<ModalBody>
				<Button color="danger" className="ml-1" onClick={props.deleteUser}>{I18n[props.lang].modal.delete}</Button>
				<Button color="secondary" className="ml-1" onClick={() => props.toggle(null)}>{I18n[props.lang].modal.cancel}</Button>
			</ModalBody>
		</Modal>
	)
};

export default DeleteUserModal;



// WEBPACK FOOTER //
// ./src/components/Users/DeleteUserModal.js